import React, { PureComponent } from 'react'
import IT from 'react-immutable-proptypes'
import T from 'prop-types'
import {
  // TextInput,
  ScrollBars,
  // CircleLoader,
  AnimateHeight,
  SaveButton,
  ErrorState,
  // Button
} from 'react-base'
import {
  fromJS
} from 'immutable'
import {
  SCHEMA_SHAPE
} from '../shapes'
import Timeline from './timeline/Timeline'

export const GRAPH_TYPES = {
  TIMELINE: 'TIMELINE'
}

export default class Graph extends PureComponent {
  static displayName = 'Schemer.Graph'

  static propTypes = {
    schema: SCHEMA_SHAPE.isRequired,
    // data: IT.map(), // TODO more formal?
    graphType: T.oneOf(Object.keys(GRAPH_TYPES)),
  }

  static defaultProps = {
    graphType: GRAPH_TYPES.TIMELINE
  }

  renderGraphInner = () => {
    const {
      graphType,
      data,
      schema
    } = this.props

    switch (graphType) {
      case GRAPH_TYPES.TIMELINE:
        return (
          <Timeline
            schema={schema}
            timeseriesData={data}

            className="anomaly_timeline"
            lineInterpolation={'linear' /*"monotone"*/}
            yTicks={5}
            xTicks={5}
            width={600}
            axisBottom
            axisLeft
            graphStyleInitial={'MONOTONE'/*'STEP_AFTER'*/}
            strokeWidth={1}
            strokeOpacity={0.5}
            fillOpacity={0.5}
            stackStreams={false}
            overlayRenderer={this.renderAnomalyValueOverlay}
            renderKey
          />
        )
      default:
        return (
          <div>Invalid Graph Type</div>
        )
    }
  }

  render() {
    const  {
      schema,
      data
    } = this.props

    return (
      <div
        className={`schemer_graph`}
      >
        <header className="schemer_form_header">Graph Header</header>
        {this.renderGraphInner()}
      </div>
    )
  }
}